// OOO — Calm PDP landing page interactions
// Prefix: ooo-calmpdp-
// Reuses foundation: window.OOOCart (ooo-cart.js), .ooo-reveal (ooo-motion.js)
// Guard against double-registration
if (!customElements.get('ooo-calmpdp-buybox')) {

  // ── 1. Buy-option selector (updates CTA label) ──
  function oooWireOpts(groupSel, ctaSel, prefix) {
    var group = document.querySelector(groupSel);
    var cta   = document.querySelector(ctaSel);
    if (!group) return;
    var opts = group.querySelectorAll('.ooo-calmpdp-opt');
    opts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        opts.forEach(function(o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        if (cta) {
          var label = opt.dataset.label || '';
          cta.textContent = prefix.replace('{price}', label);
        }
      });
    });
  }
  oooWireOpts('[data-ooo-buyopts]',  '[data-ooo-addcart]',  'Add to Cart — {price}');
  oooWireOpts('[data-ooo-startopts]', '[data-ooo-addcart2]', 'Add to Cart — {price} →');

  // ── 2. Quantity stepper ──
  (function() {
    var val = document.querySelector('[data-ooo-qtyval]');
    if (!val) return;
    document.querySelectorAll('[data-ooo-qtybtn]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var delta = parseInt(btn.dataset.oooQtybtn, 10);
        var n = Math.max(1, Math.min(99, parseInt(val.textContent, 10) + delta));
        val.textContent = n;
      });
    });
  })();

  // ── 3. Product gallery thumbnail swap ──
  (function() {
    var main = document.querySelector('[data-ooo-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-ooo-gthumb]').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        document.querySelectorAll('[data-ooo-gthumb]').forEach(function(t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        var src = thumb.dataset.oooGthumb;
        if (src) {
          main.style.opacity = '0';
          setTimeout(function() {
            main.src = src;
            main.style.opacity = '1';
          }, 150);
        }
      });
    });
  })();

  // ── 4. Add to cart — intercept both CTA buttons ──
  document.querySelectorAll('[data-ooo-addcart], [data-ooo-addcart2]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      // Find variant id from the closest active opt, or from button's form
      var form = btn.closest('form');
      var variantInput = form ? form.querySelector('[name="id"]') : null;
      var variantId = variantInput ? variantInput.value : '';
      if (!variantId) {
        // gracefully open cart without adding
        if (window.OOOCart) window.OOOCart.open();
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function() {
        if (window.OOOCart) {
          window.OOOCart.refresh();
        }
      })
      .catch(function() {
        if (window.OOOCart) window.OOOCart.open();
      });
    });
  });

  // ── 5. Stagger reveal for data-ooo-stagger groups ──
  // (ooo-motion.js handles .ooo-reveal; this adds it to children of stagger groups)
  document.querySelectorAll('[data-ooo-stagger]').forEach(function(parent) {
    Array.from(parent.children).forEach(function(child, i) {
      if (!child.classList.contains('ooo-reveal')) {
        child.classList.add('ooo-reveal');
        child.style.setProperty('--ooo-reveal-delay', (i * 0.08) + 's');
      }
    });
  });

  // Register sentinel so this guard works if script loaded twice
  customElements.define('ooo-calmpdp-buybox', class extends HTMLElement {});
}
